module.exports = __webpack_public_path__ + "img/mones.a09de1ab.jpg";